import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IModelInfo } from "../../entities/nu-model-info";
import { ClientNotifier } from "../../scripts/ah.mb.client-notifications";
import { DirectoryServices } from "../../scripts/ah.mb.ui.directory-services";

@Component
export default class DownloadModelDialog extends Vue {


    @Prop()
    value: IModelInfo;

    @Prop()
    directoryServices: DirectoryServices;


    // Create user notifier
    private userNotifier = new ClientNotifier();


    onCancelClick() {
        this.$emit("dialogClosed", "cancel");

    }

    onDownloadClick() {
        this.userNotifier.showNotification("Downloading model...", true, false);

        var chooser = (this.$refs.scenarioChooser) as any;
        var selectedScenarioNames = chooser.selectedScenarioNames as Array<string>;

        this.directoryServices.downloadModel(this.value.name, selectedScenarioNames);
        this.$emit("dialogClosed", "ok");
    }

}



// WEBPACK FOOTER //
// ./ClientApp/components/download-model-dialog/download-model-dialog.ts